import request from "@assets/js/axios";
const {
  instance: $axios
} = request;
class Tour {
  constructor() {}
  // 通用数据
  baseData(data) {
    return $axios.get('/api/v2/tour/basedata')
  }
  list(data) {
    return $axios.get('/api/v2/tour/pageQuery', {
      params: data
    });
  }
  detail(id) {
    return $axios.get('/api/v2/tour/show/' + id);
  }
  add(data) {
    return $axios.post('/api/v2/tourorder/store', data);
  }
  orderDetail(order_sn) {
    return $axios.get('/api/v2/tourorder/getOrderByUser', {
      params: {
        order_sn
      }
    });
  }
  orderList(params) {
    return $axios.get('/api/v2/tourorder/getOrdersByUser', {
      params
    });
  }
  getAd() {
    return $axios.get('/api/v2/tourAd');
  }

  getTourBaseData() {
    return $axios.get('/apiv1/goods/tours');
  }

  // 通过ID获取旅游产品详情信息
  getTravelDetailById(id) {
    return $axios.get('/apiv1/goods/get?id=' + id);
  }

  // 提交 旅游订单
  saveTravelOrder(postInfo) {
    return $axios.post('/api/xorder/save', postInfo);
  }

  // 通过订单号,获取订单详情信息
  getOrderDetailByOrderSn(order_sn) {
    return $axios.get('/api/xorder/detail?order_sn=' + order_sn);
  }

  // 通过分类ID获取 某个分类产品的基础数据
  getCategoryBaseData(category_id) {
    return $axios.get('/apiv1/goods/getBaseData?category_id=' + category_id);
  }

  // 获取旅游产品列表
  getTravelListByCategory(param) {
    return $axios.post('/apiv1/goods/list', param);
  }
  // 选择国家标签时
  getDestinationsByCountry(country_id) {
    return $axios.get('/apiv1/goods/getDestinationsByCountry?country_id=' + country_id);
  }

}

export default new Tour();